<template>
  <div class="inventario-panel-row">
    <CRow class="py-2">
      <CCol>
        <h4 class="inventario-panel-subtitle">{{ row.name }}</h4>
      </CCol>
      <CCol class="d-flex justify-content-end">
        <CButton
          v-if="crud && hasAdd"
          color="success"
          @click="toggleModal(-1, null)"
          class="mr-1"
        >
          <CIcon class="mr-1" name="cil-pencil" /> Registrar {{ row.singular }}
        </CButton>
      </CCol>
    </CRow>
    <CDataTable
      hover
      bordered
      small
      fixed
      :loading="isLoading"
      :items="items"
      :fields="fields"
    >
      <template #over-table> </template>

      <template #folio-header>
        <div class="d-flex flex-row">
          <span class="align-self-center">Folio</span>
        </div>
      </template>

      <template #folio="{ item }">
        <td class="py-2">
          {{ item.folio }}
        </td>
      </template>
      <template #fechahora_="{ item }">
        <td class="py-2">
          {{
            item.fechahora_ ? moment(item.fechahora_).format("DD/MM/YYYY") : ""
          }}
        </td>
      </template>
      <template #fechahora="{ item }">
        <td class="py-2">
          {{
            item.fechahora ? moment(item.fechahora).format("DD/MM/YYYY") : ""
          }}
        </td>
      </template>
      <template #hora="{ item }">
        <td class="py-2">
          {{ item.fechahora ? moment(item.fechahora).format("HH:mm:ss") : "" }}
        </td>
      </template>
      <template #created_at="{ item }">
        <td class="py-2">
          {{
            item.created_at
              ? moment(item.created_at).format("DD/MM/YYYY HH:mm")
              : ""
          }}
        </td>
      </template>
      <template #tiempo_extra="{ item }">
        <td class="py-2">
          {{ item.tiempo_extra ? "Si" : "" }}
        </td>
      </template>
      <template #ubicacion_raiz_id="{ item }">
        <td class="py-2">
          {{ item._relaciones.ubicacion_raiz.payload.nombre }}
        </td>
      </template>
      <template #actividad_id="{ item }">
        <td class="py-2">
          {{ item._relaciones.actividad.payload.nombre }}
        </td>
      </template>
      <template #tipo="{ item }">
        <td class="py-2">
          {{ item._relaciones.actividad.payload.tipo }}
        </td>
      </template>
      <template #trabajador_id="{ item }">
        <td class="py-2">
          {{ item._relaciones.trabajador.payload.nombre }}
        </td>
      </template>
      <template #author="{ item }">
        <td class="py-2">
          {{ item.author.scope }}
        </td>
      </template>

      <template #cantidad_costo="{ item }">
        <td class="py-2 text-right">
          {{ $formatter(item.cantidad_costo, 0, ".00") }}
        </td>
      </template>
      <template #monto_="{ item }">
        <td class="py-2 text-right">
          {{ $formatter(item.costo_unitario * item.cantidad_costo, 1) }}
        </td>
      </template>
      <template #monto="{ item }">
        <td class="py-2 text-right">
          {{ $formatter(item.monto ? item.monto : 0, 1) }}
        </td>
      </template>
      <template #semanas="{ item }">
        <td class="py-2 text-right">
          {{ item.semanas }}
        </td>
      </template>
      <template #costo_unitario="{ item }">
        <td class="py-2 text-right">
          {{ $formatter(item.costo_unitario, 1) }}
        </td>
      </template>
      <template #total="{ item }">
        <td class="py-2 text-right">
          {{ $formatter(item.cantidad_costo * item.costo_unitario, 1) }}
        </td>
      </template>
      <template #data_="{ item }">
        <td class="py-2">
          {{ item }}
        </td>
      </template>
      <template #data="{ item }">
        <td class="py-2">
          {{ Object.keys(item) }}
          <br />
          {{ Object.keys(item._relaciones) }}
        </td>
      </template>

      <template #ver="{ item }">
        <td class="py-2">
          <router-link
            :to="{
              name: row.view,
              params: {
                id: item.folio,
                folio: item.folio,
                goBack: {
                  name: 'VerCalculoAdministrativoNomina',
                  params: {
                    id: folio,
                  },
                },
              },
            }"
          >
            <CButton color="success" square size="sm">Ver</CButton>
          </router-link>
        </td>
      </template>
      <template #edit="{ item, index }">
        <td class="py-2">
          <CButton
            @click="toggleModal(index, item)"
            color="primary"
            square
            size="sm"
            >Editar</CButton
          >
        </td>
      </template>

      <template #cancel="{ item, index }">
        <td class="py-2">
          <CButton
            color="danger"
            square
            size="sm"
            @click="toggleCancel(index, item)"
            >Cancelar</CButton
          >
        </td>
      </template>
      <template #under-table>
        <div class="footer-table"></div>
      </template>
    </CDataTable>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Cancelar"
      color="danger"
    >
      <h5 class="text-center">
        ¿Deseas cancelar {{ row.cancelTitle }} con folio
        {{ this.itemModal.name }}?
      </h5>
      <template #header>
        <h5 class="modal-title">Cancelar {{ row.singular }}</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton
          @click="cancelDocto(itemModal.index, itemModal.id)"
          color="success"
          >Aceptar</CButton
        >
      </template>
    </CModal>
    <CModal
      v-if="crud && (hasAdd || hasEdit)"
      size="lg"
      :show.sync="formModal"
      :no-close-on-backdrop="true"
      :centered="true"
      :title="row.singular"
      color="info"
    >
      <AsistenciasForm
        v-if="row.schema === 'asistencias'"
        :isLoadingPage="isLoadingPage"
        :trabajadores="trabajadores"
        @handledSubmit="(fn) => (handledSubmit = fn)"
        @setData="(fn) => (setData = fn)"
      />
      <LaborForm
        class="justify-content-center"
        v-if="row.schema === 'labores'"
        :isLoadingPage="isLoadingPage"
        :ubicaciones="ubicaciones"
        :trabajadores="trabajadores"
        :actividades="actividades"
        :ubicacionesAll="ubicacionesAll"
        :trabajadoresAll="trabajadoresAll"
        :actividadesAll="actividadesAll"
        :fetching="fetching"
        @handledSubmit="(fn) => (handledSubmit = fn)"
        @setData="(fn) => (setData = fn)"
        @onFetch="
          () => {
            fetching = false;
          }
        "
        @onErrorFetch="
          (err) => {
            fetching = false;
            error = err;
            warningModal = true;
          }
        "
        :pushMedia="pushMedia"
      />

      <BonoForm
        v-if="row.schema === 'bonos'"
        :isLoadingPage="isLoadingPage"
        :ubicaciones="ubicaciones"
        :trabajadores="trabajadores"
        :ubicacionesAll="ubicacionesAll"
        :trabajadoresAll="trabajadoresAll"
        :fetching="fetching"
        @handledSubmit="(fn) => (handledSubmit = fn)"
        @setData="(fn) => (setData = fn)"
        @onFetch="
          () => {
            fetching = false;
          }
        "
        @onErrorFetch="
          (err) => {
            fetching = false;
            error = err;
            warningModal = true;
          }
        "
        :pushMedia="pushMedia"
      />

      <CajaAhorroForm
        v-if="row.schema === 'caja_de_ahorro'"
        :isLoadingPage="isLoadingPage"
        :trabajadores="trabajadores"
        :trabajadoresAll="trabajadoresAll"
        :fetching="fetching"
        @handledSubmit="(fn) => (handledSubmit = fn)"
        @setData="(fn) => (setData = fn)"
        @onFetch="
          () => {
            fetching = false;
          }
        "
        @onErrorFetch="
          (err) => {
            fetching = false;
            error = err;
            warningModal = true;
          }
        "
        :pushMedia="pushMedia"
      />

      <PrestamoForm
        v-if="row.schema === 'prestamos'"
        :trabajadores="trabajadores"
        :trabajadoresAll="trabajadoresAll"
        :isLoadingPage="isLoadingPage"
        :fetching="fetching"
        @handledSubmit="(fn) => (handledSubmit = fn)"
        @setData="(fn) => (setData = fn)"
        @onFetch="
          () => {
            fetching = false;
          }
        "
        @onErrorFetch="
          (err) => {
            fetching = false;
            error = err;
            warningModal = true;
          }
        "
        :pushMedia="pushMedia"
      />

      <CAlert v-if="warningModal" color="warning">{{ error }}</CAlert>

      <template #header>
        <h5 class="modal-title">
          {{ itemModal.index > -1 ? "Editar" : "Registrar" }} {{ row.singular }}
        </h5>
        <CButtonClose @click="formModal = false" class="text-white" />
      </template>
      <template #footer v-if="!isLoading">
        <CButton @click="formModal = false" color="danger">Cancelar</CButton>
        <CButton @click="addItem" color="success">Aceptar</CButton>
      </template>
      <template #footer v-else>
        <CSpinner />
      </template>
    </CModal>
  </div>
</template>

<script>
import DocsTranslationMixin from "../../../mixins/DocsTranslationMixin";

/*
Prestaciones

Folio | Ubicación Raíz | Actividad | Cantidad Costo | Costo Unitario | Total (Cantidad Costo por costo unitario)

Bonos aplicados

Folio | Ubicación Raíz | Concepto | Monto

Cajas aplicadas

Folio | Ubicación Raíz | Monto

Préstamos aplicados

Folio | Ubicación Raíz | Monto
*/
export default {
  name: "SimpleTableCalculoAdministrativo",
  mixins: [DocsTranslationMixin],
  data() {
    return {
      cancelModal: false,
      formModal: false,
      itemModal: { id: "", name: "", index: "" },
      isLoading: false,
      items: [],
      folio: this.$route.params.id,
    };
  },
  created() {
    if (this.row.children.length > 0) {
      this.actualizarInfo();
    } else {
      this.items = [];
    }
  },
  watch: {
    "row.children"(newValue) {
      if (newValue.length === 0) {
        debugger;
        this.items = [];
      }
    },
    cancelModal(newValue) {
      if (!newValue) {
        this.itemModal = { id: "", name: "", index: "", item: undefined };
      }
    },
    formModal(newValue) {
      if (!newValue) {
        this.itemModal = { id: "", name: "", index: "", item: undefined };
      }
    },
    row(newValue) {
      if (newValue.children.length > 0) {
        this.actualizarInfo();
      }
    },
  },
  methods: {
    cancelDocto(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customDocumentoCancelHTTP", {
          schema: this.row.schema,
          folio: id,
        })
        .then(() => {
          // console.log(res.data);
          // const index = this.items.findIndex(item => item.folio == id);
          // // console.log(this.items[index]);

          // this.items[index].estado = "cancelado";
          //this.actualizarInfo();
          this.items.splice(index, 1);
          setTimeout(() => {
            this.$emit("getData", false);
          }, 2000);
          // this.updateData();
        })
        .catch((rej) => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;

          // if (index !== -1) {
          //   this.items.splice(index, 1);
          // }
          this.cancelModal = false;
        });
    },
    toggleModal(index, item) {
      console.log(item, index);
      const itemIndex = {
        id: item?.folio,
        name: item?.nombre ?? item?.folio ?? "",
        index: index,
        item: item,
      };
      this.itemModal = itemIndex;
      this.formModal = true;
      this.setData(this.formData);
    },
    actualizarInfo() {
      this.isLoading = true;
      const body = {
        schema: this.row.schema,
        "with-storage": ["*"],
        filter: {
          wherein: [
            {
              field: `doc_${this.row.schema}.payload->encabezado->ubicacion_raiz_id`,
              value: this.ubicaciones_,
            },
            {
              field: `doc_${this.row.schema}.folio`,
              value: this.row.children.map((m) => m.folio),
            },
          ],
        },
      };
      console.log(body);
      this.$store
        .dispatch("customDocumentoHTTP", body)
        .then((res) => {
          const items = this.row.children.map(({ folio }) => {
            const { payload, ...rest } = res.data.find(
              (f) => f.folio === folio
            );
            return {
              folio,
              ...rest,
              ...(payload?.encabezado ?? {}),
              fechahora_: rest.fechahora,
            };
          });
          console.log(body.schema,items);
          debugger;
          this.items = items;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.folio,
        name: item.folio,
        index: index,
        item: item,
      };
      this.itemModal = itemIndex;
    },
  },
  props: {
    hasTheCredential: {
      type: Function,
      default: () => {},
    },
    crud: {
      type: Boolean,
      default: false,
    },
    nomina: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({
        name: "",
        view: "",
        schema: "",
        children: [],
      }),
    },

    trabajador: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasAdd() {
      return this.hasTheCredential(`@view:schema=${this.row.schema}\\|.*crear`);
    },
    hasEdit() {
      return this.hasTheCredential(
        `@view:schema=${this.row.schema}\\|.*editar`
      );
    },
    hasDel() {
      return this.hasTheCredential(
        `@view:schema=${this.row.schema}\\|.*cancelar`
      );
    },
    ubicaciones_() {
      return this.$store.state.rootLocations?.map((m) => m.value);
    },
  },
};
</script>

<style lang="scss" scoped></style>
